import angular from 'angular';

import service from './optimizely.service';
import activeTests from './activeTests';

export default angular.module('cars.activeTest.optimizely', [
    /* your module dependencies go here */
])

.service('optimizely', service)
.constant('activeTests', activeTests)

.name;
